BetterModals =
  init: ->
    @bindLinks()
    @bindCancelButton()
    @bindAlternateCloseEvents()

  # Bind any links with 'data-better-modal-link=true'
  bindLinks: ->
    $(document).on 'click', '[data-better-modal-link=true]', (event) =>
      modalLink = $(event.target).closest('[data-better-modal-link=true]')
      targetModal = modalLink.data('modal')
      @reloadIframes($(targetModal))
      if modalLink.data('better-modal-ajax')
        $(targetModal).data('modal-ajax', 'true')
      if modalLink.data('better-modal-reload')
        $(targetModal).data('modal-reload', 'true')

      @showModal($(targetModal))
      event.preventDefault()

    $(document).on 'click', '.close-modal', (event) =>
      target = $(event.target).data('target')
      @closeModal($(target))
      $(document).off 'keyup.closeBetterModal'

  bindCloseButton: ->
    $('.better-modal-close-icon').on 'click', (event) =>
      target = $(event.target).data('target')
      @closeModal($(target))
      $(target + '.show-video-modal iframe').attr 'src', ''

  # Dynamically bind any 'cancel' buttons so we don't have to write more JS
  # elsewhere...
  bindCancelButton: ->
    $(document).on 'click', '[data-better-modal-cancel=true]', (event) =>
      event.preventDefault()
      @closeModal($(event.currentTarget).closest('.better-modal'))

  # Dynamically add a 'close' button so we don't have to hard code it
  addCloseButton: (modal) ->
    if modal.data('close-button-added') != 'true'
      modal.find('.better-modal-contents')
        .prepend(
          '<button data-target="#' +
          modal.attr('id') +
          '" class="better-modal-close-icon"><span class="visually-hidden">close</span></button>'
        )
      modal.data('close-button-added', 'true')
      @bindCloseButton()

  # Add paging buttons if ajax modal
  addPagingButtons: (modal) ->
    if modal.data('modal-ajax') == 'true' &&
       modal.data('paging-buttons-added') != 'true'
      next = '<button data-target="javascript:;" class="better-modal-pager-next \
              icon-chevron-right"><span class="visually-hidden">Next</span></button>'
      prev = '<button data-target="javascript:;" class="better-modal-pager-prev \
              icon-chevron-left"><span class="visually-hidden">Prev</span></button>'
      modal.find('.better-modal-contents').prepend(next + prev)
      modal.data('paging-buttons-added', 'true')
      # @bindPagingButtons()

  # Open the modal, give it a nice 'top' value, and add the close button
  # The 'modal' parameter should be a jquery object.
  showModal: (modal) ->
    @addCloseButton(modal)
    @addPagingButtons(modal)
    $('body').append(modal)
    $('body').addClass('modal-open')
    modal.addClass('better-modal-visible')

  closeModal: (modal) ->
    $('body').removeClass('modal-open').trigger 'App::BetterModals::close', [modal]
    modal.removeClass('better-modal-visible')
    # Ajax content is overwritten on each load, so mark close button as not
    # added, so that it can reloaded on next modal load.
    modal.data(
      'close-button-added',
      'false'
    ) if modal.data('modal-ajax') == 'true' ||
         modal.data('modal-reload') == 'true'
    modal.data(
      'paging-buttons-added',
      'false'
    ) if modal.data('modal-ajax') == 'true' ||
         modal.data('modal-reload') == 'true'
    @removeIframes(modal)

  removeIframes: (modal) ->
    $iframes = modal.find('iframe')
    $iframes.each (idx, iframe) ->
      $(iframe)
        .data('src', $(iframe).attr('src'))
        .attr('src', '')

  reloadIframes: (modal) ->
    $iframes = modal.find('iframe')
    $iframes.each (idx, iframe) ->
      if (!$(iframe).attr('src') and $(iframe).data('src'))
        $(iframe).attr('src', $(iframe).data('src'))

  # These alternate 'close' events can be attached to things like Submit buttons
  # with a data attribute. This way, we don't have to manually set up these
  # handlers in a separate JS file
  bindAlternateCloseEvents: ->
    $(document).on 'click', '[data-better-modal-close=true]', (event) =>
      @closeModal($(event.currentTarget).closest('.better-modal'))

    $(document).on 'keyup.closeBetterModal', (e) =>
      target = $('.better-modal-close-icon').data('target')
      e.stopPropagation() if e.key == "Escape" && @closeModal($(target))


$ ->
  BetterModals.init()

global.BetterModals = BetterModals

export default BetterModals
